import React, { useState, useContext, useEffect, useCallback } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import MyContext from '../../../contexts/_ModalData/modal';

import './styles.css'

export default (props) => {

    const { denunciations } = useContext(MyContext);

    const [questions, setQuestions] = useState([]);

    const question1Message1 = 'Pouco movimentado.\n\n';
    const question1Message2 = 'Mal iluminado.\n\n';
    const question1Message3 = 'Não frequentado por outras mulheres.\n\n';
    const question1Message0 = 'Outros.\n\n';

    const question2Message1 = 'Tive a impressão de estar sendo encarada, fotografada, etc.\n\n';
    const question2Message2 = 'Tive a impressão de estar sendo seguida.\n\n';
    const question2Message3 = 'Fui trancada/encurralada em um cômodo, banheiro, parede, etc.\n\n';
    const question2Message4 = 'Acho que alguém colocou algo na minha bebida sem autorização.\n\n';
    const question2Message0 = 'Outros.\n\n';

    const question3Message1 = 'Pela presença.\n\n';
    const question3Message2 = 'Pela ausência.\n\n';
    const question3Message3 = 'Não está relacionada ao policiamento.\n\n';

    const question4Message1 = 'Constrangimento físico de natureza sexual (beijo forçado, passada de mão, estupro, etc...).\n\n';
    const question4Message2 = 'Constrangimento físico de natureza diversa (empurrão, tapa, toque indesejado, etc...).\n\n';
    const question4Message3 = 'Importunação sonora (buzina, gemido, assovio, etc...).\n\n';
    const question4Message4 = 'Importunação verbal (cantada, xingamento, ameaça, etc...).\n\n';
    const question4Message5 = 'Meu “não” foi ignorado (fui pressionada a dançar, a beber ou usar drogas, tirar a roupa, etc...).\n\n';
    const question4Message0 = 'Outros.\n\n';

    const question5Message1 = 'Sim.\n\n';
    const question5Message2 = 'Não.\n\n';
    const question5Message3 = 'Não sei dizer.\n\n';

    const [loaded, setLoaded] = useState(false);
    const [isChecked, setIsChecked] = useState([]);

    const handleLoadQuestions = useCallback(() => {
        setQuestions(denunciations.form);
        questions.forEach( (question) => {
            if (question[0] === 1) {
                setIsChecked((state) => [...state, true]);
            }else{
                setIsChecked((state) => [...state, false]);
            }
            setLoaded(true);
        }); 
    }, [denunciations.form, questions]);

    useEffect(() => {
        if(!loaded) {
            if (denunciations.form !== undefined) {
                handleLoadQuestions();
            }
        }
    }, [denunciations.form, handleLoadQuestions, isChecked, loaded, questions]);

    return(
        <div>
            <Dialog
                open={props.showModal} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='sm'
            >
                <DialogContent>
                    <h2 className='modal-pj-title'>{props.title}</h2> <br/><br/>
                    <div>
                        

                        <div className='modal-checkboxes'>
                            <h4>Qual impressão você teve do local?</h4>

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ1M1'    
                                        checked={isChecked[0]} 
                                        name="checkedQ1M1" 
                                        color='primary'
                                    />
                                }
                                label={question1Message1}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ1M2'
                                        checked={isChecked[1]} 
                                        name="checkedQ1M2" 
                                        color='primary'
                                    />
                                }
                                label={question1Message2}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ1M3'
                                        checked={isChecked[2]} 
                                        name="checkedQ1M3" 
                                        color='primary'
                                    />
                                }
                                label={question1Message3}
                                disabled={props.showProgress}
                            />
                                
                            
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ1M0'
                                        checked={isChecked[3]} 
                                        name="checkedQ1M0" 
                                        color='primary'
                                    />
                                }
                                label={question1Message0}
                                disabled={props.showProgress}
                            />
                            <br/> <br/> 
                            
                        </div>

                        {/* QUESTIONARIO 2 */}

                        <div className='modal-checkboxes'>
                            <h4>Por que você se sentiu insegura?</h4>

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ2M1'    
                                        checked={isChecked[4]} 
                                        name="checkedQ2M1" 
                                        color='primary'
                                    />
                                }
                                label={question2Message1}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ2M2'
                                        checked={isChecked[5]} 
                                        name="checkedQ2M2" 
                                        color='primary'
                                    />
                                }
                                label={question2Message2}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ2M2'
                                        checked={isChecked[6]} 
                                        name="checkedQ2M2" 
                                        color='primary'
                                    />
                                }
                                label={question2Message2}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ2M3'
                                        checked={isChecked[7]} 
                                        name="checkedQ2M3" 
                                        color='primary'
                                    />
                                }
                                label={question2Message3}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ2M4'
                                        checked={isChecked[8]} 
                                        name="checkedQ2M4" 
                                        color='primary'
                                    />
                                }
                                label={question2Message4}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ2M0'
                                        checked={isChecked[9]} 
                                        name="checkedQ2M0" 
                                        color='primary'
                                    />
                                }
                                label={question2Message0}
                                disabled={props.showProgress}
                            />

                            <br/> <br/> 

                        </div>

                        {/* QUESTIONARIO 3 */}
                        <div className='modal-checkboxes'>
                            <h4>Sua insegurança está relacionado ao policiamento?</h4>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ3M1'
                                        checked={isChecked[10]} 
                                        name="checkedQ1M2" 
                                        color='primary'
                                    />
                                }
                                label={question3Message1}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ3M2'
                                        checked={isChecked[11]} 
                                        name="checkedQ3M2" 
                                        color='primary'
                                    />
                                }
                                label={question3Message2}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ3M3'
                                        checked={isChecked[12]} 
                                        name="checkedQ3M3" 
                                        color='primary'
                                    />
                                }
                                label={question3Message3}
                                disabled={props.showProgress}
                            />
                        </div>
                       
                        {/* QUESTIONARIO 4 */}
                        <div className='modal-checkboxes'>
                            <h4>Sofreu assédio?</h4>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ4M1'
                                        checked={isChecked[13]} 
                                        name="checkedQ4M1" 
                                        color='primary'
                                    />
                                }
                                label={question4Message1}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ4M2'
                                        checked={isChecked[14]} 
                                        name="checkedQ4M2" 
                                        color='primary'
                                    />
                                }
                                label={question4Message2}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ4M3'
                                        checked={isChecked[15]} 
                                        name="checkedQ4M3" 
                                        color='primary'
                                    />
                                }
                                label={question4Message3}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ4M4'
                                        checked={isChecked[16]} 
                                        name="checkedQ4M4" 
                                        color='primary'
                                    />
                                }
                                label={question4Message4}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ4M5'
                                        checked={isChecked[17]} 
                                        name="checkedQ4M5" 
                                        color='primary'
                                    />
                                }
                                label={question4Message5}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ4M0'
                                        checked={isChecked[18]} 
                                        name="checkedQ4M0" 
                                        color='primary'
                                    />
                                }
                                label={question4Message0}
                                disabled={props.showProgress}
                            />
                        </div>

                        {/* QUESTIONARIO 5 */}

                        <div className='modal-checkboxes'>
                            <h4>Algum responsável pelo local (público/privado) tomou alguma providência?</h4>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ5M1'
                                        checked={isChecked[19]} 
                                        name="checkedQ5M1" 
                                        color='primary'
                                    />
                                }
                                label={question5Message1}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ5M2'
                                        checked={isChecked[20]} 
                                        name="checkedQ5M2" 
                                        color='primary'
                                    />
                                }
                                label={question5Message2}
                                disabled={props.showProgress}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='checkQ5M3'
                                        checked={isChecked[21]} 
                                        name="checkedQ5M3" 
                                        color='primary'
                                    />
                                }
                                label={question5Message3}
                                disabled={props.showProgress}
                            />
                        </div>
                    </div>
                    <div className='questionario-button'>
                        <p className='card-profiles-text-button' id='voltar-questionario-button'onClick={() => {props.decline(false)}}>Voltar</p>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}